import { render, staticRenderFns } from "./NewEditMatriculaPage.vue?vue&type=template&id=aea998e6"
import script from "./NewEditMatriculaPage.vue?vue&type=script&lang=js"
export * from "./NewEditMatriculaPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditMatriculaPage.vue?vue&type=style&index=0&id=aea998e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports